import React from 'react';
import { arrayOf, element, object, oneOfType } from 'prop-types';
import styled from 'styled-components';
import Wrapper from '../Wrapper';

const FooterCTAContainer = styled(Wrapper)`
  clear: both;
  box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.04);
  position: relative;
  left: 0;
  bottom: 0;
`;

FooterCTAContainer.defaultProps = {
  padding: [4, 5],
  borderRadius: 4,
  maxHeight: [87, 128],
  minHeight: [32, 48],
  border: 'none',
  backgroundColor: ['primaryWhite', 'greyLighter'],
  style: { elevation: 10 },
};

const FooterCTABox = ({ children, containerProps }) => (
  <FooterCTAContainer {...containerProps}>{children}</FooterCTAContainer>
);

FooterCTABox.propTypes = {
  children: oneOfType([element, arrayOf(element)]),
  containerProps: object,
};

export default FooterCTABox;
